import { useSelector } from 'react-redux'
import TopDownChannel from './TopDownChannel'
import { RootState } from '@/stores'
import HorizontalMeasurement from '../lines/HorizontalMeasurement'
import Slab from '../common/Slab'

const slabProperties = {
  slabWidth: 140,
  slabHeight: 80,
}

const channelProperties = {
  channelWidth: 80,
  channelHeight: 20,
}

const measurementProperties = {
  measurementYPadding: 20,
}

const derivedProperties = {
  channelXOffset: (slabProperties.slabWidth / 2) - (channelProperties.channelWidth / 2),
  channelYOffset: (slabProperties.slabHeight / 2) - (channelProperties.channelHeight / 2),
  measurementYOffset: slabProperties.slabHeight + measurementProperties.measurementYPadding,
}

type PropTypes = {
  yOffset?: number,
}

const TopDownDiagram = ({ yOffset = 0 }: PropTypes) => {
  const channel = useSelector((state: RootState) => state.activeDesign.design?.components?.find(c => c.cast_in_anchor_channel))

  return (
    <g>
      <Slab
        height={slabProperties.slabHeight}
        width={slabProperties.slabWidth}
        yOffset={yOffset}
      />
      {
        channel
        && (
          <TopDownChannel
            height={channelProperties.channelHeight}
            width={channelProperties.channelWidth}
            xOffset={derivedProperties.channelXOffset}
            yOffset={yOffset + derivedProperties.channelYOffset}
            channel={channel}
          />
        )
      }
      {
        channel
        && (
          <g>
            <HorizontalMeasurement
              startPoint={0}
              endPoint={derivedProperties.channelXOffset}
              yOffset={yOffset + derivedProperties.measurementYOffset}
              label="e2,1"
            />
            <HorizontalMeasurement
              startPoint={derivedProperties.channelXOffset + channelProperties.channelWidth}
              endPoint={slabProperties.slabWidth}
              yOffset={yOffset + derivedProperties.measurementYOffset}
              label="e2,2"
            />
          </g>
        )
      }
    </g>
  )
}

export default TopDownDiagram
